import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
// import Socket from "./Sockets/socket";

// import axios from 'axios'

Vue.use(Router)
let router = new Router({
	mode: 'history',
	routes: [
		{
			path: '/minister',
			component: () => import('./layouts/minister'),
			meta: {
				requiresAuth: true,
			},
			children: [
				{
					path: 'dashboard',
					name: 'ministerDashboard',
					meta: { role: 'minister', requiresAuth: true },
					component: () => import('./views/Minister/ministerDashboard')
				},
				{
					path: 'map',
					name: 'ministerMap',
					meta: { role: 'minister', requiresAuth: true },
					component: () => import('./views/Minister/ministerMap')
				},
				{
					path: 'incidents',
					name: 'ministerIncidents',
					meta: { role: 'minister', requiresAuth: true },
					component: () => import('./views/Minister/ministerIncidents')
				},
				{
					path: 'unassigned',
					name: 'ministerUnassigned',
					meta: { role: 'minister', requiresAuth: true },
					component: () => import('./views/Minister/ministerUnassigned')
				},
				{
					path: '',
					redirect: { name: 'ministerDashboard' }
				}
			]
		},
		{
			path: '/analyst',
			component: () => import('./layouts/analyst'),
			meta: {
				requiresAuth: true,
			},
			children: [
				{
					path: 'snakerescued',
					name: 'analystSnakeRescued',
					meta: { role: 'analyst', requiresAuth: true },
					component: () => import('./views/Sarpa/Dashboard/snakeRescuedmap.vue')
				},
				{
					path: '',
					redirect: { name: 'analystSnakeRescued' }
				}
			]
		},
		{
			path: '/maps/unmapped',
			redirect: '/snakerescued'
		},
		{
			path: '/maps',
			redirect: '/snakerescued'
		},

		{
			path: '/admin',
			props: true,
			component: () => import('./layouts/admin'),
			meta: {
				requiresAuth: true,
			},
			children: [
				{
					path: 'adminDashboard',
					name: 'adminDashboard',
					meta: { role: 'admin', requiresAuth: true },
					component: () => import('./views/Dashboard/dashboardAdmin')
				},

				{
					path: '',
					name: 'adminDashboard',
					meta: { role: 'admin', requiresAuth: true },
					component: () => import('./views/Dashboard/dashboardAdmin')
				},

				{
					path: 'profile',
					name: 'profile',
					meta: { role: 'admin', requiresAuth: true },
					component: () => import('./views/Profile/profile')
				},
				{
					path: 'adddeoc',
					name: 'adddeoc',
					meta: { role: 'admin', requiresAuth: true },
					component: () => import('./views/Admin/Cases/addDeoc')
				},
				{
					path: 'addrrt',
					name: 'addrrt',
					meta: { role: 'admin', requiresAuth: true },
					component: () => import('./views/Admin/Cases/addRrt')
				},
				{
					path: 'addSeoc',
					name: 'addSeoc',
					meta: { role: 'admin', requiresAuth: true },
					component: () => import('./views/Admin/Cases/addSeoc')
				},
				{
					path: 'addminister',
					name: 'addminister',
					meta: { role: 'admin', requiresAuth: true },
					component: () => import('./views/Admin/Cases/addMinister')
				},
				{
					path: 'addanalyst',
					name: 'addanalyst',
					meta: { role: 'admin', requiresAuth: true },
					component: () => import('./views/Admin/Cases/addAnalyst')
				},

				{
					path: 'conflictReports',
					name: 'conflictReports',
					// meta: {
					// 	requiresAuth: true,
					// },
					meta: { role: 'admin', requiresAuth: true },
					component: () => import('./views/ConflictReports/conflictReports')
				},
				{
					path: 'emergencyUser',
					name: 'emergencyUser',
					meta: { role: 'admin', requiresAuth: true },
					component: () => import('./views/EmergencyUser/adduser')
				},
				{
					path: 'reportCase',
					name: 'reportCase',
					meta: { role: 'admin', requiresAuth: true },
					component: () => import('./views/ReportCase/reportCase')
				},
				{
					path: 'resolveCase',
					name: 'resolveCase',
					meta: { role: 'admin', requiresAuth: true },
					component: () => import('./views/ResolveCase/resolveCase')
				},
				{
					path: 'releaseCase',
					name: 'releaseCase',
					meta: { role: 'admin', requiresAuth: true },
					component: () => import('./views/ReleaseCase/releaseCaseAdmin')
				},
				{
					path: 'myreport',
					name: 'myreport',
					meta: { role: 'admin', requiresAuth: true },
					component: () => import('./views/MyReports/myReport')
				},
				{
					path: 'closedcases',
					name: 'closedcases',
					meta: { role: 'admin', requiresAuth: true },
					component: () => import('./views/ClosedCases/closed')
				},
				{
					path: 'mapping',
					name: 'mapping',
					meta: { role: 'admin', requiresAuth: true },
					component: () => import('./views/Map/map')
				},
				{
					path: 'daily-report',
					name: 'daily-report',
					meta: { role: 'admin', requiresAuth: true },
					component: () => import('./views/Officers/dailyReport.vue')
				},
				{
					path: 'daily-reporting/:id?',
					name: 'daily-reporting',
					meta: { role: 'admin', requiresAuth: true },
					component: () => import('./views/Officers/dailyReporting.vue')
				},
				{
					path: 'daily-report-rescue',
					name: 'daily-report-rescue',
					meta: { role: 'admin', requiresAuth: true },
					component: () => import('./views/Officers/RescueReport/detailedView.vue')
				},
				{
					path: 'daily-reporting-rescue/:id?',
					name: 'daily-reporting-rescue',
					meta: { role: 'admin', requiresAuth: true },
					component: () => import('./views/Officers/RescueReport/addCase.vue')
				},
				{
					path: 'fencing-list',
					name: 'fencing-list',
					meta: { role: 'admin', requiresAuth: true },
					component: () => import('./views/Fencing/fencingList.vue')
				},
				{
					path: 'fencing-view',
					name: 'fencing-view',
					meta: { role: 'admin', requiresAuth: true },
					component: () => import('./views/Fencing/fencingView.vue')
				},
				{
					path: 'mergedlist',
					name: 'mergedlist',
					meta: { role: 'admin', requiresAuth: true },
					component: () => import('./views/MergedCases/merged')
				},
				{
					path: 'editresolveCase',
					name: 'editresolveCase',
					meta: { role: 'admin', requiresAuth: true },
					component: () => import('./views/EditResolve/resolveEditadmin')
				},
				{
					path: 'public',
					meta: {
						requiresAuth: true,
					},
					component: {
						render(c) { return c('router-view') }
					},
					children: [
						{
							path: '',
							name: 'public',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Admin/Public/public')
						},
						{

							path: 'reports',
							name: 'reports',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Admin/Public/reports')
						},
					],
				},
				{
					path: 'mergeCases',
					meta: {
						requiresAuth: true,
					},
					component: {
						render(c) { return c('router-view') }
					},
					children: [
						{
							path: "",
							name: "MergeCase",
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Admin/MergeCases/mergeCases'),
							props: true,
						},
						{
							path: "mergeCaseSuggestion",
							name: "MergeCase",
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Admin/MergeCases/mergeCaseSuggestion'),
							props: true,
						}
					]
				},
				{
					path: 'dynamicData',
					meta: {
						requiresAuth: true,
					},
					component: {
						render(c) { return c('router-view') }
					},
					children: [

						{

							path: 'scenerios',
							name: 'scenerios',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Admin/DynamicData/Scenerios/scenerios')
						},

						{

							path: 'animals',
							name: 'animals',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Admin/DynamicData/Animals/Animals')
						},
						{

							path: 'animalActivities',
							name: 'animalActivities',
							// meta: {
							// 	requiresAuth: true,
							// },
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Admin/DynamicData/AnimalActivities/animalActivities')
						},
						{

							path: 'animalAge',
							name: 'animalAge',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Admin/DynamicData/AnimalAge/animalAge')
						},
						{

							path: 'animalStatus',
							name: 'animalStatus',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Admin/DynamicData/AnimalStatus/animalStatus')
						},
						{

							path: 'gender',
							name: 'gender',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Admin/DynamicData/Gender/gender')
						},
						{

							path: 'assets',
							name: 'assets',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Admin/DynamicData/Assets/assets')
						},
						{

							path: 'mitigationTypes',
							name: 'mitigationType',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Admin/DynamicData/Mitigations/mitigationTypes')
						},
						{

							path: 'mitigationMethods',
							name: 'mitigationMethod',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Admin/DynamicData/Mitigations/mitigationMethods')
						},
						{

							path: 'releaseTypes',
							name: 'releaseType',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Admin/DynamicData/ReleaseTypes/releaseTypes')
						},
						{

							path: 'landTypes',
							name: 'landType',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Admin/DynamicData/LandTypes/landTypes')
						},
						{

							path: 'breachType',
							name: 'breachType',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Admin/DynamicData/BreachType/breachType')
						},
						{

							path: 'barrierType',
							name: 'barrierType',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Admin/DynamicData/BarrierType/barrierType')
						},
						{

							path: 'conflictType',
							name: 'conflictType',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Admin/DynamicData/ConflictType/conflictType')
						},
						{

							path: 'cropType',
							name: 'cropType',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Admin/DynamicData/CropType/cropType')
						},
						{

							path: 'veterinaryRecommendation',
							name: 'veterinaryRecommendation',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Admin/DynamicData/VeterinaryRecommendation/veterinaryRecommendation')
						},
						{

							path: 'closeStatus',
							name: 'closeStatus',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Admin/DynamicData/CloseStatus/closeStatus')
						},
					],
				},
				{
					path: 'sarpa',
					meta: {
						requiresAuth: true,
					},
					component: {
						render(c) { return c('router-view') }
					},
					children: [
						{

							path: '/Sarpa/dashboard',
							name: 'sarpadashboard',
							// meta: {
							// 	requiresAuth: true,
							// },
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Sarpa/Dashboard/dashboard')
						},
						{

							path: '/topcommonsnakes',
							name: 'topcommonsnakes',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Sarpa/Dashboard/topSnakes.vue')
						},
						{

							path: '/usermap',
							name: 'usermap',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Sarpa/Dashboard/userMap.vue')
						},
						{

							path: '/rescuermap',
							name: 'rescuermap',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Sarpa/Dashboard/rescuerMap.vue')
						},
						{

							path: '/hospitalMap',
							name: 'hospitalMap',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Sarpa/Dashboard/hospitalMap.vue')
						},
						{

							path: '/listedSnakes',
							name: 'listedSnakes',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Sarpa/Dashboard/listedSnakes.vue')
						},
						{

							path: '/editSnake',
							name: 'editSnake',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Sarpa/Dashboard/editSnake.vue')
						},
						{

							path: '/snakedetails',
							name: 'snakedetails',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Sarpa/Dashboard/snakeDetails.vue')
						},
						{

							path: '/snakebiteDeath',
							name: 'snakebiteDeath',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Sarpa/Dashboard/snakebiteDeath.vue')
						},
						{

							path: '/snakerescued',
							name: 'snakerescued',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Sarpa/Dashboard/snakeRescuedmap.vue')
						},
						{

							path: '/topUsers',
							name: 'topUsers',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Sarpa/Dashboard/topUsers.vue')
						},
						{
							path: '/rescuerDashboard/:id',
							name: 'rescuerDashboard',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Sarpa/Dashboard/rescuerDashboard.vue')
						},
						{

							path: '/topUsersyear',
							name: 'topUsersyear',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Sarpa/Dashboard/topUsersyear.vue')
						},
						{

							path: '/addSnakes',
							name: 'addSnakes',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Sarpa/Addsnakes/addSnakes.vue')
						},
						{

							path: '/aiImages/snake-types',
							name: 'snake-types',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Sarpa/AIImages/snakeTypes.vue')
						},
						{

							path: '/aiImages/:id',
							name: 'aiImages',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Sarpa/AIImages/aiImages.vue')
						},
						{

							path: '/usersList',
							name: 'usersList',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Sarpa/UserList/usersList.vue')
						},
						{

							path: '/edituser',
							name: 'edituser',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Sarpa/UserList/editUser.vue')
						},
						{

							path: '/newrescuerslist',
							name: 'newrescuerslist',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Sarpa/NewRescuers/newList.vue')
						},
						{

							path: '/newrescuerslistview',
							name: 'newrescuerslistview',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Sarpa/NewRescuers/viewDetails.vue')
						},
						{

							path: '/newrescuerslistedit',
							name: 'newrescuerslistedit',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Sarpa/NewRescuers/editDetails.vue')
						},



						//single side bar for rescuers
						{
							path: '/rescuers',
							name: 'rescuers',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Sarpa/RescuerList/RescuerManager.vue')
						},


						{

							path: '/allrescuerlist',
							name: 'allrescuerlist',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Sarpa/RescuerList/alluserlist.vue')
						},
						{

							path: '/bannedrescuerlist',
							name: 'bannedrescuerlist',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Sarpa/RescuerList/bannedList.vue')
						},
						{

							path: '/rescuerslistview',
							name: 'rescuerslistview',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Sarpa/RescuerList/viewDetails.vue')
						},
						{

							path: '/pendingoperations',
							name: 'pendingoperations',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Sarpa/PendingOperations/pending.vue')
						},
						{

							path: '/approveoperations',
							name: 'approveoperations',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Sarpa/ApproveOperations/list.vue')
						},
						{

							path: '/viewpendingoperations',
							name: 'viewpendingoperations',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Sarpa/PendingOperations/viewPending.vue')
						},
						{

							path: '/assignedoperations',
							name: 'assignedoperations',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Sarpa/AssignedOperations/list.vue')
						},
						{

							path: '/assignedoperationsview',
							name: 'assignedoperationsview',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Sarpa/SnakeReports/view.vue')
						},
						{

							path: '/rescuedoperations',
							name: 'rescuedoperations',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Sarpa/RescuedOperations/list.vue')
						},
						{

							path: '/rescuedoperationsview',
							name: 'rescuedoperationsview',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Sarpa/SnakeReports/view.vue')
						},
						{

							path: '/releasedoperations',
							name: 'releasedoperations',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Sarpa/ReleasedOperations/list.vue')
						},
						{

							path: '/releasedoperationsview',
							name: 'releasedoperationsview',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Sarpa/SnakeReports/view.vue')
						},
						{

							path: '/approvedoperationsview',
							name: 'approvedoperationsview',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Sarpa/SnakeReports/view.vue')
						},
						{

							path: '/approvedoperations',
							name: 'approvedoperations',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Sarpa/ApprovedOperations/list.vue')
						},
						{

							path: '/approvedoperationsview',
							name: 'approvedoperationsview',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Sarpa/SnakeReports/view.vue')
						},
						{

							path: '/deleteoperations',
							name: 'deleteoperations',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Sarpa/DeleteOperations/list.vue')
						},
						{

							path: '/deleteoperationsview',
							name: 'deleteoperationsview',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Sarpa/SnakeReports/view.vue')
						},
						{

							path: '/traininglist',
							name: 'traininglist',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Sarpa/TrainingList/list.vue')
						},
						{

							path: '/traininglistview',
							name: 'traininglistview',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Sarpa/TrainingList/view.vue')
						},
						{

							path: '/snakereports',
							name: 'snakereports',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Sarpa/SnakeReports/list.vue')
						},
						{

							path: '/snakereportsview',
							name: 'snakereportsview',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Sarpa/SnakeReports/view.vue')
						},
						{

							path: '/addsnakeexperts',
							name: 'addsnakeexperts',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Sarpa/AddSnakeExperts/add.vue')
						},
						{

							path: '/addhospital',
							name: 'addhospital',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Sarpa/AddHospital/add.vue')
						},
						{

							path: '/Viewhospital',
							name: 'Viewhospital',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Sarpa/ViewHospital/list.vue')
						},
						{

							path: '/edithospital',
							name: 'edithospital',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Sarpa/ViewHospital/edit.vue')
						},
						{

							path: '/identificationhelp',
							name: 'identificationhelp',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Sarpa/Identification/help.vue')
						},

						{

							path: '/excelreport',
							name: 'excelreport',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Sarpa/Excel/excelReport.vue')
						},
						{

							path: '/identificationhelpview',
							name: 'identificationhelpview',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Sarpa/Identification/helpview.vue')
						},
						{

							path: '/approvehospital',
							name: 'approvehospital',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Sarpa/ApproveHospital/list.vue')
						},
						{

							path: '/reportGeneration',
							name: 'reportGeneration',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/FilterData/filterData.vue')
						},

						//add badge levels
						{
							path : '/badgelevels',
							name : 'badgelevels',
							meta : { role :'admin', requiresAuth : true},
							component: () => import('./views/Sarpa/BadgeLevels/list.vue')
						},

						//rating
						{
							path: '/ratingsoperations',
							name: 'ratingsoperations',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Sarpa/RatingsOperations/list.vue')
						},

						{
							path: '/about-sarpa-rescuers',
							name: 'aboutSarpaRescuers',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Sarpa/ContentEditor/sarparescures.vue')
						},
						{
							path: '/manage-privacy-policy',
							name: 'privacyPolicy',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Sarpa/ContentEditor/PrivacyPolicy.vue')
						},
						{
							path: '/terms-and-conditions',
							name: 'termsAndConditions',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Sarpa/ContentEditor/TermsAndConditions.vue')
						},
						{
							path: '/about-us',
							name: 'aboutUs',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Sarpa/ContentEditor/AboutUs.vue')
						},
						{
							path: '/mission-and-vision',
							name: 'missionAndVision',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Sarpa/ContentEditor/MissionAndVision.vue')
						},
						{
							path: '/back-story',
							name: 'backStory',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Sarpa/ContentEditor/BackStory.vue')
						},

						//fraudcases
						{
							path: '/fraudoperations',
							name: 'fraudOperation',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Sarpa/FraudCases/fraudlist.vue')
						},
						{
							path: '/fraudoperationsview',
							name: 'fraudView',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Sarpa/FraudCases/fraudview.vue')
						}



					],
				},
				{
					path: 'cases',
					meta: {
						requiresAuth: true,
					},
					component: {
						render(c) { return c('router-view') }
					},
					children: [
						{
							path: 'caseDetails',
							name: 'caseDetails',
							meta: { role: 'admin', requiresAuth: true },
							component: () => import('./views/Admin/Cases/caseDetails')
						},
					],
				},
				{
					path: 'notifications',
					name: 'notification',
					props: true,
					component: () => import('./views/Notifications/notifications'),
					meta: { role: 'admin', requiresAuth: true },
				},
				{
					path: 'analytics',
					name: 'Analytics',
					props: true,
					component: () => import('./views/Analytics/analytics'),
					meta: { role: 'admin', requiresAuth: true },
				},
				{
					path: 'analyticspage',
					name: 'analyticspage',
					props: true,
					component: () => import('./views/Analytics/newAnalytics'),
					meta: { role: 'admin', requiresAuth: true },
				},
				{
					path: 'elephant-reports',
					name: 'elephant-reports',
					props: true,
					component: () => import('./views/Analytics/elephantReport'),
					meta: { role: 'admin', requiresAuth: true },
				},
				{
					path: 'tiger-reports',
					name: 'tiger-reports',
					props: true,
					component: () => import('./views/Analytics/tigerReport'),
					meta: { role: 'admin', requiresAuth: true },
				},
				{
					path: 'human-deaths',
					name: 'human-deaths',
					props: true,
					component: () => import('./views/Analytics/humandeathCard'),
					meta: { role: 'admin', requiresAuth: true },
				},
				{
					path: 'animal-deaths',
					name: 'animal-deaths',
					props: true,
					component: () => import('./views/Analytics/animalDeath'),
					meta: { role: 'admin', requiresAuth: true },
				},
				{
					path: 'animal-captures',
					name: 'animal-captures',
					props: true,
					component: () => import('./views/Analytics/animalCaptured'),
					meta: { role: 'admin', requiresAuth: true },
				},
				{
					path: 'animal-injuries',
					name: 'animal-injuries',
					props: true,
					component: () => import('./views/Analytics/animalInjury'),
					meta: { role: 'admin', requiresAuth: true },
				},
				{
					path: 'human-injury',
					name: 'human-injury',
					props: true,
					component: () => import('./views/Analytics/humanInjury'),
					meta: { role: 'admin', requiresAuth: true },
				},
				{
					path: 'animal-released',
					name: 'animal-released',
					props: true,
					component: () => import('./views/Analytics/animalReleased'),
					meta: { role: 'admin', requiresAuth: true },
				},
				{
					path: 'district-details',
					name: 'district-details',
					props: true,
					component: () => import('./views/Analytics/districtDetails'),
					meta: { role: 'admin', requiresAuth: true },
				},
				{
					path: 'card-details',
					name: 'card-details',
					props: true,
					component: () => import('./views/Analytics/cardDetails'),
					meta: { role: 'admin', requiresAuth: true },
				},
				{
					path: 'case-details',
					name: 'case-details',
					props: true,
					component: () => import('./views/Analytics/caseDetails'),
					meta: { role: 'admin', requiresAuth: true },
				},
				{
					path: 'commonanalyticspage',
					name: 'commonanalyticspage',
					props: { analyticType: 'hwc' },
					component: () => import('./views/Analytics/commonDash'),
					meta: { role: 'admin', requiresAuth: true, analyticType: 'hwc' },
				},
				{
					path: 'hwcanalyticspage',
					name: 'hwcanalyticspage',
					props: { analyticType: 'hwc' },
					component: () => import('./views/Analytics/commonDash'),
					meta: { role: 'admin', requiresAuth: true, analyticType: 'hwc' },
				},
				{
					path: 'sarpaanalyticspage',
					name: 'sarpaanalyticspage',
					props: { analyticType: 'sarpa' },
					component: () => import('./views/Analytics/commonDash'),
					meta: { role: 'admin', requiresAuth: true, analyticType: 'sarpa' },
				},
				{
					path: 'commonanalyticspage/incidents',
					name: 'adminCommonIncidents',
					props: true,
					component: () => import('./views/Minister/ministerIncidents'),
					meta: { role: 'admin', requiresAuth: true },
				},
				{
					path: 'commonanalyticspage/unassigned',
					name: 'adminCommonUnassigned',
					props: true,
					component: () => import('./views/Minister/ministerUnassigned'),
					meta: { role: 'admin', requiresAuth: true },
				},
			]
		},

		{
			path: '/emergencyuser',
			props: true,
			component: () => import('./layouts/emergencyuser'),
			meta: {
				requiresAuth: true,
			},
			children: [
				{
					path: 'adminDashboard',
					name: 'adminDashboard',
					meta: { role: 'EmergencyUser', requiresAuth: true },
					component: () => import('./views/Dashboard/dashboardAdmin')
				},

				{
					path: '',
					name: 'adminDashboard',
					meta: { role: 'EmergencyUser', requiresAuth: true },
					component: () => import('./views/Dashboard/dashboardAdmin')
				},

				{
					path: 'profile',
					name: 'profile',
					meta: { role: 'EmergencyUser', requiresAuth: true },
					component: () => import('./views/Profile/profile')
				},
				{
					path: 'adddeoc',
					name: 'adddeoc',
					meta: { role: 'EmergencyUser', requiresAuth: true },
					component: () => import('./views/Admin/Cases/addDeoc')
				},
				{
					path: 'addrrt',
					name: 'addrrt',
					meta: { role: 'EmergencyUser', requiresAuth: true },
					component: () => import('./views/Admin/Cases/addRrt')
				},
				{
					path: 'addSeoc',
					name: 'addSeoc',
					meta: { role: 'EmergencyUser', requiresAuth: true },
					component: () => import('./views/Admin/Cases/addSeoc')
				},

				{
					path: 'conflictReports',
					name: 'conflictReports',
					// meta: {
					// 	requiresAuth: true,
					// },
					meta: { role: 'EmergencyUser', requiresAuth: true },
					component: () => import('./views/ConflictReports/conflictReports')
				},
				{
					path: 'emergencyUser',
					name: 'emergencyUser',
					meta: { role: 'EmergencyUser', requiresAuth: true },
					component: () => import('./views/EmergencyUser/adduser')
				},
				{
					path: 'reportCase',
					name: 'reportCase',
					meta: { role: 'EmergencyUser', requiresAuth: true },
					component: () => import('./views/ReportCase/reportCase')
				},
				{
					path: 'resolveCase',
					name: 'resolveCase',
					meta: { role: 'EmergencyUser', requiresAuth: true },
					component: () => import('./views/ResolveCase/resolveCase')
				},
				{
					path: 'releaseCase',
					name: 'releaseCase',
					meta: { role: 'EmergencyUser', requiresAuth: true },
					component: () => import('./views/ReleaseCase/releaseCaseAdmin')
				},
				{
					path: 'myreport',
					name: 'myreport',
					meta: { role: 'EmergencyUser', requiresAuth: true },
					component: () => import('./views/MyReports/myReport')
				},
				{
					path: 'closedcases',
					name: 'closedcases',
					meta: { role: 'EmergencyUser', requiresAuth: true },
					component: () => import('./views/ClosedCases/closed')
				},
				{
					path: 'mapping',
					name: 'mapping',
					meta: { role: 'EmergencyUser', requiresAuth: true },
					component: () => import('./views/Map/map')
				},
				{
					path: 'mergedlist',
					name: 'mergedlist',
					meta: { role: 'EmergencyUser', requiresAuth: true },
					component: () => import('./views/MergedCases/merged')
				},
				{
					path: 'editresolveCase',
					name: 'editresolveCase',
					meta: { role: 'EmergencyUser', requiresAuth: true },
					component: () => import('./views/EditResolve/resolveEditadmin')
				},
				{
					path: 'public',
					meta: {
						requiresAuth: true,
					},
					component: {
						render(c) { return c('router-view') }
					},
					children: [
						{
							path: '',
							name: 'public',
							meta: { role: 'EmergencyUser', requiresAuth: true },
							component: () => import('./views/Admin/Public/public')
						},
						{

							path: 'reports',
							name: 'reports',
							meta: { role: 'EmergencyUser', requiresAuth: true },
							component: () => import('./views/Admin/Public/reports')
						},
					],
				},
				{
					path: 'mergeCases',
					meta: {
						requiresAuth: true,
					},
					component: {
						render(c) { return c('router-view') }
					},
					children: [
						{
							path: "",
							name: "MergeCase",
							meta: { role: 'EmergencyUser', requiresAuth: true },
							component: () => import('./views/Admin/MergeCases/mergeCases'),
							props: true,
						},
						{
							path: "mergeCaseSuggestion",
							name: "MergeCase",
							meta: { role: 'EmergencyUser', requiresAuth: true },
							component: () => import('./views/Admin/MergeCases/mergeCaseSuggestion'),
							props: true,
						}
					]
				},
				{
					path: 'dynamicData',
					meta: {
						requiresAuth: true,
					},
					component: {
						render(c) { return c('router-view') }
					},
					children: [

						{

							path: 'scenerios',
							name: 'scenerios',
							meta: { role: 'EmergencyUser', requiresAuth: true },
							component: () => import('./views/Admin/DynamicData/Scenerios/scenerios')
						},

						{

							path: 'animals',
							name: 'animals',
							meta: { role: 'EmergencyUser', requiresAuth: true },
							component: () => import('./views/Admin/DynamicData/Animals/Animals')
						},
						{

							path: 'animalActivities',
							name: 'animalActivities',
							// meta: {
							// 	requiresAuth: true,
							// },
							meta: { role: 'EmergencyUser', requiresAuth: true },
							component: () => import('./views/Admin/DynamicData/AnimalActivities/animalActivities')
						},
						{

							path: 'animalAge',
							name: 'animalAge',
							meta: { role: 'EmergencyUser', requiresAuth: true },
							component: () => import('./views/Admin/DynamicData/AnimalAge/animalAge')
						},
						{

							path: 'animalStatus',
							name: 'animalStatus',
							meta: { role: 'EmergencyUser', requiresAuth: true },
							component: () => import('./views/Admin/DynamicData/AnimalStatus/animalStatus')
						},
						{

							path: 'gender',
							name: 'gender',
							meta: { role: 'EmergencyUser', requiresAuth: true },
							component: () => import('./views/Admin/DynamicData/Gender/gender')
						},

						{

							path: 'mitigationTypes',
							name: 'mitigationType',
							meta: { role: 'EmergencyUser', requiresAuth: true },
							component: () => import('./views/Admin/DynamicData/Mitigations/mitigationTypes')
						},
						{

							path: 'mitigationMethods',
							name: 'mitigationMethod',
							meta: { role: 'EmergencyUser', requiresAuth: true },
							component: () => import('./views/Admin/DynamicData/Mitigations/mitigationMethods')
						},
						{

							path: 'releaseTypes',
							name: 'releaseType',
							meta: { role: 'EmergencyUser', requiresAuth: true },
							component: () => import('./views/Admin/DynamicData/ReleaseTypes/releaseTypes')
						},
						{

							path: 'landTypes',
							name: 'landType',
							meta: { role: 'EmergencyUser', requiresAuth: true },
							component: () => import('./views/Admin/DynamicData/LandTypes/landTypes')
						},
						{

							path: 'breachType',
							name: 'breachType',
							meta: { role: 'EmergencyUser', requiresAuth: true },
							component: () => import('./views/Admin/DynamicData/BreachType/breachType')
						},
						{

							path: 'barrierType',
							name: 'barrierType',
							meta: { role: 'EmergencyUser', requiresAuth: true },
							component: () => import('./views/Admin/DynamicData/BarrierType/barrierType')
						},
						{

							path: 'conflictType',
							name: 'conflictType',
							meta: { role: 'EmergencyUser', requiresAuth: true },
							component: () => import('./views/Admin/DynamicData/ConflictType/conflictType')
						},
						{

							path: 'cropType',
							name: 'cropType',
							meta: { role: 'EmergencyUser', requiresAuth: true },
							component: () => import('./views/Admin/DynamicData/CropType/cropType')
						},
						{

							path: 'veterinaryRecommendation',
							name: 'veterinaryRecommendation',
							meta: { role: 'EmergencyUser', requiresAuth: true },
							component: () => import('./views/Admin/DynamicData/VeterinaryRecommendation/veterinaryRecommendation')
						},
						{

							path: 'closeStatus',
							name: 'closeStatus',
							meta: { role: 'EmergencyUser', requiresAuth: true },
							component: () => import('./views/Admin/DynamicData/CloseStatus/closeStatus')
						},
					],
				},
				{
					path: 'sarpa',
					meta: {
						requiresAuth: true,
					},
					component: {
						render(c) { return c('router-view') }
					},
					children: [
						{

							path: '/Sarpa/dashboard',
							name: 'sarpadashboard',
							// meta: {
							// 	requiresAuth: true,
							// },
							meta: { role: 'EmergencyUser', requiresAuth: true },
							component: () => import('./views/Sarpa/Dashboard/dashboard')
						},
						{

							path: '/topcommonsnakes',
							name: 'topcommonsnakes',
							meta: { role: 'EmergencyUser', requiresAuth: true },
							component: () => import('./views/Sarpa/Dashboard/topSnakes.vue')
						},
						{

							path: '/usermap',
							name: 'usermap',
							meta: { role: 'EmergencyUser', requiresAuth: true },
							component: () => import('./views/Sarpa/Dashboard/userMap.vue')
						},
						{

							path: '/rescuermap',
							name: 'rescuermap',
							meta: { role: 'EmergencyUser', requiresAuth: true },
							component: () => import('./views/Sarpa/Dashboard/rescuerMap.vue')
						},
						{

							path: '/hospitalMap',
							name: 'hospitalMap',
							meta: { role: 'EmergencyUser', requiresAuth: true },
							component: () => import('./views/Sarpa/Dashboard/hospitalMap.vue')
						},
						{

							path: '/listedSnakes',
							name: 'listedSnakes',
							meta: { role: 'EmergencyUser', requiresAuth: true },
							component: () => import('./views/Sarpa/Dashboard/listedSnakes.vue')
						},
						{

							path: '/editSnake',
							name: 'editSnake',
							meta: { role: 'EmergencyUser', requiresAuth: true },
							component: () => import('./views/Sarpa/Dashboard/editSnake.vue')
						},
						{

							path: '/snakedetails',
							name: 'snakedetails',
							meta: { role: 'EmergencyUser', requiresAuth: true },
							component: () => import('./views/Sarpa/Dashboard/snakeDetails.vue')
						},
						{

							path: '/snakebiteDeath',
							name: 'snakebiteDeath',
							meta: { role: 'EmergencyUser', requiresAuth: true },
							component: () => import('./views/Sarpa/Dashboard/snakebiteDeath.vue')
						},
						{

							path: '/snakerescued',
							name: 'snakerescued',
							meta: { role: 'EmergencyUser', requiresAuth: true },
							component: () => import('./views/Sarpa/Dashboard/snakeRescuedmap.vue')
						},
						{

							path: '/topUsers',
							name: 'topUsers',
							meta: { role: 'EmergencyUser', requiresAuth: true },
							component: () => import('./views/Sarpa/Dashboard/topUsers.vue')
						},
						{
							path: '/rescuerDashboard/:id',
							name: 'rescuerDashboard_emergency',
							meta: { role: 'EmergencyUser', requiresAuth: true },
							component: () => import('./views/Sarpa/Dashboard/rescuerDashboard.vue')
						},
						{

							path: '/topUsersyear',
							name: 'topUsersyear',
							meta: { role: 'EmergencyUser', requiresAuth: true },
							component: () => import('./views/Sarpa/Dashboard/topUsersyear.vue')
						},
						{

							path: '/addSnakes',
							name: 'addSnakes',
							meta: { role: 'EmergencyUser', requiresAuth: true },
							component: () => import('./views/Sarpa/Addsnakes/addSnakes.vue')
						},
						{

							path: '/usersList',
							name: 'usersList',
							meta: { role: 'EmergencyUser', requiresAuth: true },
							component: () => import('./views/Sarpa/UserList/usersList.vue')
						},
						{

							path: '/edituser',
							name: 'edituser',
							meta: { role: 'EmergencyUser', requiresAuth: true },
							component: () => import('./views/Sarpa/UserList/editUser.vue')
						},
						{

							path: '/newrescuerslist',
							name: 'newrescuerslist',
							meta: { role: 'EmergencyUser', requiresAuth: true },
							component: () => import('./views/Sarpa/NewRescuers/newList.vue')
						},
						{

							path: '/newrescuerslistview',
							name: 'newrescuerslistview',
							meta: { role: 'EmergencyUser', requiresAuth: true },
							component: () => import('./views/Sarpa/NewRescuers/viewDetails.vue')
						},
						{

							path: '/newrescuerslistedit',
							name: 'newrescuerslistedit',
							meta: { role: 'EmergencyUser', requiresAuth: true },
							component: () => import('./views/Sarpa/NewRescuers/editDetails.vue')
						},
						{

							path: '/allrescuerlist',
							name: 'allrescuerlist',
							meta: { role: 'EmergencyUser', requiresAuth: true },
							component: () => import('./views/Sarpa/RescuerList/alluserlist.vue')
						},
						{

							path: '/bannedrescuerlist',
							name: 'bannedrescuerlist',
							meta: { role: 'EmergencyUser', requiresAuth: true },
							component: () => import('./views/Sarpa/RescuerList/bannedList.vue')
						},
						{

							path: '/rescuerslistview',
							name: 'rescuerslistview',
							meta: { role: 'EmergencyUser', requiresAuth: true },
							component: () => import('./views/Sarpa/RescuerList/viewDetails.vue')
						},
						{

							path: '/pendingoperations',
							name: 'pendingoperations',
							meta: { role: 'EmergencyUser', requiresAuth: true },
							component: () => import('./views/Sarpa/PendingOperations/pending.vue')
						},
						{

							path: '/approveoperations',
							name: 'approveoperations',
							meta: { role: 'EmergencyUser', requiresAuth: true },
							component: () => import('./views/Sarpa/ApproveOperations/list.vue')
						},
						{

							path: '/viewpendingoperations',
							name: 'viewpendingoperations',
							meta: { role: 'EmergencyUser', requiresAuth: true },
							component: () => import('./views/Sarpa/PendingOperations/viewPending.vue')
						},
						{

							path: '/assignedoperations',
							name: 'assignedoperations',
							meta: { role: 'EmergencyUser', requiresAuth: true },
							component: () => import('./views/Sarpa/AssignedOperations/list.vue')
						},
						{

							path: '/assignedoperationsview',
							name: 'assignedoperationsview',
							meta: { role: 'EmergencyUser', requiresAuth: true },
							component: () => import('./views/Sarpa/SnakeReports/view.vue')
						},
						{

							path: '/rescuedoperations',
							name: 'rescuedoperations',
							meta: { role: 'EmergencyUser', requiresAuth: true },
							component: () => import('./views/Sarpa/RescuedOperations/list.vue')
						},
						{

							path: '/rescuedoperationsview',
							name: 'rescuedoperationsview',
							meta: { role: 'EmergencyUser', requiresAuth: true },
							component: () => import('./views/Sarpa/SnakeReports/view.vue')
						},
						{

							path: '/releasedoperations',
							name: 'releasedoperations',
							meta: { role: 'EmergencyUser', requiresAuth: true },
							component: () => import('./views/Sarpa/ReleasedOperations/list.vue')
						},
						{

							path: '/releasedoperationsview',
							name: 'releasedoperationsview',
							meta: { role: 'EmergencyUser', requiresAuth: true },
							component: () => import('./views/Sarpa/SnakeReports/view.vue')
						},
						{

							path: '/approvedoperationsview',
							name: 'approvedoperationsview',
							meta: { role: 'EmergencyUser', requiresAuth: true },
							component: () => import('./views/Sarpa/SnakeReports/view.vue')
						},
						{

							path: '/approvedoperations',
							name: 'approvedoperations',
							meta: { role: 'EmergencyUser', requiresAuth: true },
							component: () => import('./views/Sarpa/ApprovedOperations/list.vue')
						},
						{

							path: '/approvedoperationsview',
							name: 'approvedoperationsview',
							meta: { role: 'EmergencyUser', requiresAuth: true },
							component: () => import('./views/Sarpa/SnakeReports/view.vue')
						},
						{

							path: '/deleteoperations',
							name: 'deleteoperations',
							meta: { role: 'EmergencyUser', requiresAuth: true },
							component: () => import('./views/Sarpa/DeleteOperations/list.vue')
						},
						{

							path: '/deleteoperationsview',
							name: 'deleteoperationsview',
							meta: { role: 'EmergencyUser', requiresAuth: true },
							component: () => import('./views/Sarpa/SnakeReports/view.vue')
						},
						{

							path: '/traininglist',
							name: 'traininglist',
							meta: { role: 'EmergencyUser', requiresAuth: true },
							component: () => import('./views/Sarpa/TrainingList/list.vue')
						},
						{

							path: '/traininglistview',
							name: 'traininglistview',
							meta: { role: 'EmergencyUser', requiresAuth: true },
							component: () => import('./views/Sarpa/TrainingList/view.vue')
						},
						{

							path: '/snakereports',
							name: 'snakereports',
							meta: { role: 'EmergencyUser', requiresAuth: true },
							component: () => import('./views/Sarpa/SnakeReports/list.vue')
						},
						{

							path: '/snakereportsview',
							name: 'snakereportsview',
							meta: { role: 'EmergencyUser', requiresAuth: true },
							component: () => import('./views/Sarpa/SnakeReports/view.vue')
						},
						{

							path: '/addsnakeexperts',
							name: 'addsnakeexperts',
							meta: { role: 'EmergencyUser', requiresAuth: true },
							component: () => import('./views/Sarpa/AddSnakeExperts/add.vue')
						},
						{

							path: '/addhospital',
							name: 'addhospital',
							meta: { role: 'EmergencyUser', requiresAuth: true },
							component: () => import('./views/Sarpa/AddHospital/add.vue')
						},
						{

							path: '/Viewhospital',
							name: 'Viewhospital',
							meta: { role: 'EmergencyUser', requiresAuth: true },
							component: () => import('./views/Sarpa/ViewHospital/list.vue')
						},
						{

							path: '/edithospital',
							name: 'edithospital',
							meta: { role: 'EmergencyUser', requiresAuth: true },
							component: () => import('./views/Sarpa/ViewHospital/edit.vue')
						},
						{

							path: '/identificationhelp',
							name: 'identificationhelp',
							meta: { role: 'EmergencyUser', requiresAuth: true },
							component: () => import('./views/Sarpa/Identification/help.vue')
						},

						{

							path: '/excelreport',
							name: 'excelreport',
							meta: { role: 'EmergencyUser', requiresAuth: true },
							component: () => import('./views/Sarpa/Excel/excelReport.vue')
						},
						{

							path: '/identificationhelpview',
							name: 'identificationhelpview',
							meta: { role: 'EmergencyUser', requiresAuth: true },
							component: () => import('./views/Sarpa/Identification/helpview.vue')
						},
						{

							path: '/approvehospital',
							name: 'approvehospital',
							meta: { role: 'EmergencyUser', requiresAuth: true },
							component: () => import('./views/Sarpa/ApproveHospital/list.vue')
						},
						{

							path: '/reportGeneration',
							name: 'reportGeneration',
							meta: { role: 'EmergencyUser', requiresAuth: true },
							component: () => import('./views/FilterData/filterData.vue')
						},


					],
				},
				{
					path: 'cases',
					meta: {
						requiresAuth: true,
					},
					component: {
						render(c) { return c('router-view') }
					},
					children: [
						{
							path: 'caseDetails',
							name: 'caseDetails',
							meta: { role: 'EmergencyUser', requiresAuth: true },
							component: () => import('./views/Admin/Cases/caseDetails')
						},
					],
				},
				{
					path: 'notifications',
					name: 'notification',
					props: true,
					component: () => import('./views/Notifications/notifications'),
					meta: { role: 'EmergencyUser', requiresAuth: true },
				},
				{
					path: 'analytics',
					name: 'Analytics',
					props: true,
					component: () => import('./views/Analytics/analytics'),
					meta: { role: 'EmergencyUser', requiresAuth: true },
				},
				{
					path: 'analyticspage',
					name: 'analyticspage',
					props: true,
					component: () => import('./views/Analytics/newAnalytics'),
					meta: { role: 'EmergencyUser', requiresAuth: true },
				},
				{
					path: 'elephant-reports',
					name: 'elephant-reports',
					props: true,
					component: () => import('./views/Analytics/elephantReport'),
					meta: { role: 'EmergencyUser', requiresAuth: true },
				},
				{
					path: 'tiger-reports',
					name: 'tiger-reports',
					props: true,
					component: () => import('./views/Analytics/tigerReport'),
					meta: { role: 'EmergencyUser', requiresAuth: true },
				},
				{
					path: 'human-deaths',
					name: 'human-deaths',
					props: true,
					component: () => import('./views/Analytics/humandeathCard'),
					meta: { role: 'EmergencyUser', requiresAuth: true },
				},
				{
					path: 'animal-deaths',
					name: 'animal-deaths',
					props: true,
					component: () => import('./views/Analytics/animalDeath'),
					meta: { role: 'EmergencyUser', requiresAuth: true },
				},
				{
					path: 'animal-captures',
					name: 'animal-captures',
					props: true,
					component: () => import('./views/Analytics/animalCaptured'),
					meta: { role: 'EmergencyUser', requiresAuth: true },
				},
				{
					path: 'animal-injuries',
					name: 'animal-injuries',
					props: true,
					component: () => import('./views/Analytics/animalInjury'),
					meta: { role: 'EmergencyUser', requiresAuth: true },
				},
				{
					path: 'human-injury',
					name: 'human-injury',
					props: true,
					component: () => import('./views/Analytics/humanInjury'),
					meta: { role: 'EmergencyUser', requiresAuth: true },
				},
				{
					path: 'animal-released',
					name: 'animal-released',
					props: true,
					component: () => import('./views/Analytics/animalReleased'),
					meta: { role: 'EmergencyUser', requiresAuth: true },
				},
				{
					path: 'district-details',
					name: 'district-details',
					props: true,
					component: () => import('./views/Analytics/districtDetails'),
					meta: { role: 'EmergencyUser', requiresAuth: true },
				},
				{
					path: 'commonanalyticspage',
					name: 'commonanalyticspageEmergency',
					props: { analyticType: 'hwc' },
					component: () => import('./views/Analytics/commonDash'),
					meta: { role: 'EmergencyUser', requiresAuth: true, analyticType: 'hwc' },
				},
				{
					path: 'hwcanalyticspage',
					name: 'hwcanalyticspageEmergency',
					props: { analyticType: 'hwc' },
					component: () => import('./views/Analytics/commonDash'),
					meta: { role: 'EmergencyUser', requiresAuth: true, analyticType: 'hwc' },
				},
				{
					path: 'sarpaanalyticspage',
					name: 'sarpaanalyticspageEmergency',
					props: { analyticType: 'sarpa' },
					component: () => import('./views/Analytics/commonDash'),
					meta: { role: 'EmergencyUser', requiresAuth: true, analyticType: 'sarpa' },
				},
			]
		},

		{
			path: '/officers',
			props: true,
			component: () => import('./layouts/officers'),
			meta: {
				requiresAuth: true,
			},
			children: [
				{
					path: 'dashboard',
					name: 'dashboard',
					// meta: {
					// 	requiresAuth: true,
					// },
					meta: { role: 'official', requiresAuth: true },
					component: () => import('./views/Dashboard/dashboard')
				},
				{
					path: 'closedcases',
					name: 'closedcases',
					// meta: {
					// 	requiresAuth: true,
					// },
					meta: { role: 'official', requiresAuth: true },
					component: () => import('./views/ClosedCases/closed')
				},
				{
					path: '',
					name: 'dashboard',
					// meta: {
					// 	requiresAuth: true,
					// },
					meta: { role: 'official', requiresAuth: true },
					component: () => import('./views/Dashboard/dashboard')
				},
				{
					path: 'profile',
					name: 'profile',
					// meta: {
					// 	requiresAuth: true,
					// },
					meta: { role: 'official', requiresAuth: true },
					component: () => import('./views/Profile/profile')
				},
				{
					path: 'resolveCase',
					name: 'resolveCase',
					// meta: {
					// 	requiresAuth: true,
					// },
					meta: { role: 'official', requiresAuth: true },
					component: () => import('./views/ResolveCaseOfficer/ResolveCaseOfficer')
				},
				{
					path: 'editresolveCase',
					name: 'editresolveCase',
					// meta: {
					// 	requiresAuth: true,
					// },
					meta: { role: 'official', requiresAuth: true },
					component: () => import('./views/EditResolve/resolveEdit')
				},
				{

					path: 'reportGenerationofficers',
					name: 'reportGenerationofficers',
					// meta: {
					// 	requiresAuth: true,
					// },
					meta: { role: 'official', requiresAuth: true },
					component: () => import('./views/FilterData/filterDataofficer.vue')
				},
				{
					path: 'conflictReports',
					name: 'conflictReports',
					// meta: {
					// 	requiresAuth: true,
					// },
					meta: { role: 'official', requiresAuth: true },
					component: () => import('./views/ConflictReports/conflictReports')
				},
				{
					path: 'adddeoc',
					name: 'adddeoc',
					// meta: {
					// 	requiresAuth: true,
					// },
					meta: { role: 'official', requiresAuth: true },
					component: () => import('./views/Officers/Cases/addDeoc')
				},
				{
					path: 'addSeoc',
					name: 'addSeoc',
					// meta: {
					// 	requiresAuth: true,
					// },
					meta: { role: 'official', requiresAuth: true },
					component: () => import('./views/Officers/Cases/addSeoc')
				},
				{
					path: 'officers',
					name: 'officersSection',
					// meta: {
					// 	requiresAuth: true,
					// },
					meta: { role: 'official', requiresAuth: true },
					component: () => import('./views/Officers/Officers/officers')
				},
				{
					path: 'public',
					meta: {
						requiresAuth: true,
					},
					// meta: { role: 'official', requiresAuth: true },
					component: {
						render(c) { return c('router-view') }
					},
					children: [
						{
							path: '',
							name: 'public',
							meta: { role: 'official', requiresAuth: true },
							component: () => import('./views/Officers/Public/public')
						},
						// {

						// 	path: 'reports',
						// 	name: 'reports',
						// 	meta: {
						// 		requiresAuth: true,
						// 	},
						// 	component: () => import('./views/Admin/Public/reports')
						// },
					],
				},
				{
					path: 'cases',
					meta: {
						requiresAuth: true,
					},
					component: {
						render(c) { return c('router-view') }
					},
					children: [
						{
							path: 'caseDetails',
							name: 'caseDetails',
							meta: { role: 'official', requiresAuth: true },
							component: () => import('./views/Officers/Cases/caseDetails')
						},
					],
				},
				{
					path: 'mergeCases',
					meta: {
						requiresAuth: true,
					},
					component: {
						render(c) { return c('router-view') }
					},
					children: [
						{
							path: "",
							name: "MergeCase",
							meta: { role: 'official', requiresAuth: true },
							component: () => import('./views/Officers/MergeCases/mergeCases'),
							props: true,
						},
						{
							path: "mergeCaseSuggestion",
							name: "MergeCase",
							meta: { role: 'official', requiresAuth: true },
							component: () => import('./views/Officers/MergeCases/mergeCaseSuggestion'),
							props: true,
						}
					]
				},
				{
					path: 'notifications',
					name: 'notification',
					props: true,
					component: () => import('./views/Notifications/notifications'),
					meta: { role: 'official', requiresAuth: true },
				},
				{
					path: 'analytics',
					name: 'Analytics',
					props: true,
					component: () => import('./views/Analytics/newAnalytics'),
					meta: { role: 'official', requiresAuth: true },
				},
				{
					path: 'elephant-reports',
					name: 'elephant-reports',
					props: true,
					component: () => import('./views/Analytics/elephantReport'),
					meta: { role: 'official', requiresAuth: true },
				},
				{
					path: 'tiger-reports',
					name: 'tiger-reports',
					props: true,
					component: () => import('./views/Analytics/tigerReport'),
					meta: { role: 'official', requiresAuth: true },
				},
				{
					path: 'human-deaths',
					name: 'human-deaths',
					props: true,
					component: () => import('./views/Analytics/humandeathCard'),
					meta: { role: 'official', requiresAuth: true },
				},
				{
					path: 'animal-deaths',
					name: 'animal-deaths',
					props: true,
					component: () => import('./views/Analytics/animalDeath'),
					meta: { role: 'official', requiresAuth: true },
				},
				{
					path: 'animal-captures',
					name: 'animal-captures',
					props: true,
					component: () => import('./views/Analytics/animalCaptured'),
					meta: { role: 'official', requiresAuth: true },
				},
				{
					path: 'animal-injuries',
					name: 'animal-injuries',
					props: true,
					component: () => import('./views/Analytics/animalInjury'),
					meta: { role: 'official', requiresAuth: true },
				},
				{
					path: 'human-injury',
					name: 'human-injury',
					props: true,
					component: () => import('./views/Analytics/humanInjury'),
					meta: { role: 'official', requiresAuth: true },
				},
				{
					path: 'animal-released',
					name: 'animal-released',
					props: true,
					component: () => import('./views/Analytics/animalReleased'),
					meta: { role: 'official', requiresAuth: true },
				},
				{
					path: 'district-details',
					name: 'district-details',
					props: true,
					component: () => import('./views/Analytics/districtDetails'),
					meta: { role: 'official', requiresAuth: true },
				},
				{
					path: 'card-details',
					name: 'card-details',
					props: true,
					component: () => import('./views/Analytics/cardDetails'),
					meta: { role: 'official', requiresAuth: true },
				},
				{
					path: 'case-details',
					name: 'case-details',
					props: true,
					component: () => import('./views/Analytics/caseDetails'),
					meta: { role: 'admin', requiresAuth: true },
				},
				{
					path: 'daily-report',
					name: 'daily-report',
					props: true,
					component: () => import('./views/Officers/dailyReport.vue'),
					meta: { role: 'official', requiresAuth: true },
				},
				{
					path: 'daily-reporting/:id?',
					name: 'daily-reporting',
					meta: { role: 'official', requiresAuth: true },
					component: () => import('./views/Officers/dailyReporting.vue')
				},
				{
					path: 'daily-report-rescue',
					name: 'daily-report-rescue',
					meta: { role: 'official', requiresAuth: true },
					component: () => import('./views/Officers/RescueReport/detailedView.vue')
				},
				{
					path: 'daily-reporting-rescue/:id?',
					name: 'daily-reporting-rescue',
					meta: { role: 'official', requiresAuth: true },
					component: () => import('./views/Officers/RescueReport/addCase.vue')
				},
				{
					path: 'reportcase',
					name: 'reportcase',
					props: true,
					component: () => import('./views/ReportCase/reportCase'),
					meta: { role: 'official', requiresAuth: true },
				},
				{
					path: 'resolvecase',
					name: 'resolvecase',
					props: true,
					component: () => import('./views/ResolveCase/resolveCase'),
					meta: { role: 'official', requiresAuth: true },
				},
				{
					path: 'releasecase',
					name: 'releasecase',
					props: true,
					component: () => import('./views/ReleaseCase/releaseCase'),
					meta: { role: 'official', requiresAuth: true },
				},
				{

					path: 'sarpadashboard',
					name: 'officersarpadashboard',
					meta: { role: 'official', requiresAuth: true },
					component: () => import('./views/Officers/Sarpa/Dashboard/dashboard')
				},
				{

					path: 'topcommonsnakes',
					name: 'topcommonsnakes',
					meta: { role: 'official', requiresAuth: true },
					component: () => import('./views/Officers/Sarpa/Dashboard/topSnakes.vue')
				},
				{

					path: 'usermap',
					name: 'usermap',
					meta: { role: 'official', requiresAuth: true },
					component: () => import('./views/Officers/Sarpa/Dashboard/userMap.vue')
				},
				{

					path: 'rescuermap',
					name: 'rescuermap',
					meta: { role: 'official', requiresAuth: true },
					component: () => import('./views/Officers/Sarpa/Dashboard/rescuerMap.vue')
				},
				{

					path: 'hospitalMap',
					name: 'hospitalMap',
					meta: { role: 'official', requiresAuth: true },
					component: () => import('./views/Officers/Sarpa/Dashboard/hospitalMap.vue')
				},
				{

					path: 'listedSnakes',
					name: 'listedSnakes',
					meta: { role: 'official', requiresAuth: true },
					component: () => import('./views/Officers/Sarpa/Dashboard/listedSnakes.vue')
				},
				{

					path: 'editSnake',
					name: 'editSnake',
					meta: { role: 'official', requiresAuth: true },
					component: () => import('./views/Sarpa/Dashboard/editSnake.vue')
				},
				{

					path: 'snakedetails',
					name: 'snakedetails',
					meta: { role: 'official', requiresAuth: true },
					component: () => import('./views/Officers/Sarpa/Dashboard/snakeDetails.vue')
				},
				{

					path: 'snakebiteDeath',
					name: 'snakebiteDeath',
					meta: { role: 'official', requiresAuth: true },
					component: () => import('./views/Officers/Sarpa/Dashboard/snakebiteDeath.vue')
				},
				{

					path: 'snakerescued',
					name: 'snakerescued',
					meta: { role: 'official', requiresAuth: true },
					component: () => import('./views/Officers/Sarpa/Dashboard/snakeRescuedmap.vue')
				},
				{

					path: 'topUsers',
					name: 'topUsers',
					meta: { role: 'official', requiresAuth: true },
					component: () => import('./views/Officers/Sarpa/Dashboard/topUsers.vue')
				},
				{
					path: 'rescuerDashboard/:id',
					name: 'rescuerDashboard_officer',
					meta: { role: 'official', requiresAuth: true },
					component: () => import('./views/Sarpa/Dashboard/rescuerDashboard.vue')
				},
				{

					path: 'topUsersyear',
					name: 'topUsersyear',
					meta: { role: 'official', requiresAuth: true },
					component: () => import('./views/Officers/Sarpa/Dashboard/topUsersyear.vue')
				},
				{

					path: 'addSnakes',
					name: 'addSnakes',
					meta: { role: 'official', requiresAuth: true },
					component: () => import('./views/Officers/Sarpa/Addsnakes/addSnakes.vue')
				},
				{

					path: 'usersList',
					name: 'usersList',
					meta: { role: 'official', requiresAuth: true },
					component: () => import('./views/Officers/Sarpa/UserList/usersList.vue')
				},
				{

					path: 'edituser',
					name: 'edituser',
					meta: { role: 'official', requiresAuth: true },
					component: () => import('./views/Officers/Sarpa/UserList/editUser.vue')
				},
				{

					path: 'newrescuerslist',
					name: 'newrescuerslist',
					meta: { role: 'official', requiresAuth: true },
					component: () => import('./views/Officers/Sarpa/NewRescuers/newList.vue')
				},
				{

					path: 'newrescuerslistview',
					name: 'newrescuerslistview',
					meta: { role: 'official', requiresAuth: true },
					component: () => import('./views/Officers/Sarpa/NewRescuers/viewDetails.vue')
				},
				{

					path: 'newrescuerslistedit',
					name: 'newrescuerslistedit',
					meta: { role: 'official', requiresAuth: true },
					component: () => import('./views/Officers/Sarpa/NewRescuers/editDetails.vue')
				},
				{

					path: 'allrescuerlist',
					name: 'allrescuerlist',
					meta: { role: 'official', requiresAuth: true },
					component: () => import('./views/Officers/Sarpa/RescuerList/alluserlist.vue')
				},
				{

					path: 'rescuerslistview',
					name: 'rescuerslistview',
					meta: { role: 'official', requiresAuth: true },
					component: () => import('./views/Officers/Sarpa/RescuerList/viewDetails.vue')
				},
				{

					path: 'pendingoperations',
					name: 'pendingoperations',
					meta: { role: 'official', requiresAuth: true },
					component: () => import('./views/Officers/Sarpa/PendingOperations/pending.vue')
				},
				{

					path: 'viewpendingoperations',
					name: 'viewpendingoperations',
					meta: { role: 'official', requiresAuth: true },
					component: () => import('./views/Officers/Sarpa/PendingOperations/viewPending.vue')
				},
				{

					path: 'assignedoperations',
					name: 'assignedoperations',
					meta: { role: 'official', requiresAuth: true },
					component: () => import('./views/Officers/Sarpa/AssignedOperations/list.vue')
				},
				{

					path: 'assignedoperationsview',
					name: 'assignedoperationsview',
					meta: { role: 'official', requiresAuth: true },
					component: () => import('./views/Officers/Sarpa/SnakeReports/view.vue')
				},
				{

					path: 'rescuedoperations',
					name: 'rescuedoperations',
					meta: { role: 'official', requiresAuth: true },
					component: () => import('./views/Officers/Sarpa/RescuedOperations/list.vue')
				},
				{

					path: 'rescuedoperationsview',
					name: 'rescuedoperationsview',
					meta: { role: 'official', requiresAuth: true },
					component: () => import('./views/Officers/Sarpa/SnakeReports/view.vue')
				},
				{

					path: 'fraudoperations',
					name: 'fraudoperations',
					meta: { role: 'official', requiresAuth: true },
					component: () => import('./views/Officers/Sarpa/FraudCases/list.vue')
				},
				{

					path: 'fraudoperationsview',
					name: 'fraudoperationsview',
					meta: { role: 'official', requiresAuth: true },
					component: () => import('./views/Officers/Sarpa/SnakeReports/view.vue')
				},
				{

					path: 'releasedoperations',
					name: 'releasedoperations',
					meta: { role: 'official', requiresAuth: true },
					component: () => import('./views/Officers/Sarpa/ReleasedOperations/list.vue')
				},
				{

					path: 'releasedoperationsview',
					name: 'releasedoperationsview',
					meta: { role: 'official', requiresAuth: true },
					component: () => import('./views/Officers/Sarpa/SnakeReports/view.vue')
				},
				{

					path: 'approvedoperationsview',
					name: 'approvedoperationsview',
					meta: { role: 'official', requiresAuth: true },
					component: () => import('./views/Officers/Sarpa/SnakeReports/view.vue')
				},
				{

					path: 'approvedoperations',
					name: 'approvedoperations',
					meta: { role: 'official', requiresAuth: true },
					component: () => import('./views/Officers/Sarpa/ApprovedOperations/list.vue')
				},
				{

					path: 'approvedoperationsview',
					name: 'approvedoperationsview',
					meta: { role: 'official', requiresAuth: true },
					component: () => import('./views/Officers/Sarpa/SnakeReports/view.vue')
				},
				{

					path: 'deleteoperations',
					name: 'deleteoperations',
					meta: { role: 'official', requiresAuth: true },
					component: () => import('./views/Officers/Sarpa/DeleteOperations/list.vue')
				},
				{

					path: 'deleteoperationsview',
					name: 'deleteoperationsview',
					meta: { role: 'official', requiresAuth: true },
					component: () => import('./views/Officers/Sarpa/SnakeReports/view.vue')
				},
				{

					path: 'traininglist',
					name: 'traininglist',
					meta: { role: 'official', requiresAuth: true },
					component: () => import('./views/Officers/Sarpa/TrainingList/list.vue')
				},
				{

					path: 'traininglistview',
					name: 'traininglistview',
					meta: { role: 'official', requiresAuth: true },
					component: () => import('./views/Officers/Sarpa/TrainingList/view.vue')
				},
				{

					path: 'snakereports',
					name: 'snakereports',
					meta: { role: 'official', requiresAuth: true },
					component: () => import('./views/Officers/Sarpa/SnakeReports/list.vue')
				},
				{

					path: 'snakereportsview',
					name: 'snakereportsview',
					meta: { role: 'official', requiresAuth: true },
					component: () => import('./views/Officers/Sarpa/SnakeReports/view.vue')
				},
				{

					path: 'addsnakeexperts',
					name: 'addsnakeexperts',
					meta: { role: 'official', requiresAuth: true },
					component: () => import('./views/Officers/Sarpa/AddSnakeExperts/add.vue')
				},
				{

					path: 'addhospital',
					name: 'addhospital',
					meta: { role: 'official', requiresAuth: true },
					component: () => import('./views/Officers/Sarpa/AddHospital/add.vue')
				},
				{

					path: 'Viewhospital',
					name: 'Viewhospital',
					meta: { role: 'official', requiresAuth: true },
					component: () => import('./views/Officers/Sarpa/ViewHospital/list.vue')
				},
				{

					path: 'edithospital',
					name: 'edithospital',
					meta: { role: 'official', requiresAuth: true },
					component: () => import('./views/Officers/Sarpa/ViewHospital/edit.vue')
				},
				{

					path: 'identificationhelp',
					name: 'identificationhelp',
					meta: { role: 'official', requiresAuth: true },
					component: () => import('./views/Officers/Sarpa/Identification/help.vue')
				},

				{

					path: 'excelreport',
					name: 'excelreport',
					meta: { role: 'official', requiresAuth: true },
					component: () => import('./views/Officers/Sarpa/Excel/excelReport.vue')
				},
				{

					path: 'identificationhelpview',
					name: 'identificationhelpview',
					meta: { role: 'official', requiresAuth: true },
					component: () => import('./views/Officers/Sarpa/Identification/helpview.vue')
				},
				{

					path: 'approvehospital',
					name: 'approvehospital',
					meta: { role: 'official', requiresAuth: true },
					component: () => import('./views/Officers/Sarpa/ApproveHospital/list.vue')
				},
				{

					path: '/reportGeneration',
					name: 'reportGeneration',
					meta: { role: 'official', requiresAuth: true },
					component: () => import('./views/FilterData/filterData.vue')
				},



			],
		},

		// {
		// 	path: '/',
		// 	props: true,
		// 	component: () => import('./layouts/authentication'),
		// 	meta: {
		// 		requiresAuth: false,
		// 	},
		// 	children: [
		// 		{
		// 			path: 'login',
		// 			name: 'login',
		// 			meta: {
		// 				requiresAuth: false,
		// 			},
		// 			component: () => import('./layouts/authentication')
		// 		},
		// 	]
		// },
		{
			path: '/',
			props: true,
			component: () => import('./layouts/loginPage'),
			meta: {
				requiresAuth: false,
			},
			children: [
				{
					path: 'login',
					name: 'login',
					meta: {
						requiresAuth: false,
					},
					component: () => import('./layouts/loginPage')
				},
			]
		},
		{
			path: '/servererror',
			name: 'servererror',
			props: true,
			component: () => import('./components/Common/500'),
			meta: {
				requiresAuth: false,
			}
		},

		{
			path: '/privacy-policy',
			name: 'PublicPrivacyPolicy',
			props: true,
			component: () => import('./views/GeneralPages/PrivacyPolicy'),
			meta: {
				requiresAuth: false,
			}
		},
		{
			path: '/PrivacyPolicy',
			redirect: '/privacy-policy'
		},
		{
			path: '/delete-account',
			name: 'DeleteAccount',
			props: true,
			component: () => import('./views/GeneralPages/DeleteAccount'),
			meta: {
				requiresAuth: false,
			}
		},
		{
			path: '/deleteaccount',
			redirect: '/delete-account'
		},
		// {
		// 	path: '/map',
		// 	name: 'map',
		// 	props: true,
		// 	component: () => import('./views/Officers/Cases/map'),
		// 	meta: {
		// 		requiresAuth: false,
		// 	}
		// },
		{
			path: '*',
			name: '404pagenotfound',
			props: true,
			component: () => import('./components/Common/404'),
			meta: {
				requiresAuth: false,
			}
		},
		{

			path: '/Support',
			name: 'Support',
			meta: {
				requiresAuth: false,
			},
			component: () => import('./views/Sarpa/SupportPage/supportPage.vue')
		},

	],
	scrollBehavior() {
		document.body.scrollTop = 0; // For Safari
		document.documentElement.scrollTop = 0;
	},
})

router.beforeEach((to, from, next) => {
	// 	if(!store.state.authentication)
	// 	{
	// Socket.authFunction()
	// 	}
	if (to.matched.some(route => route.meta.requiresAuth == true) && store.state.isLoggedIn == false) {
		console.log(from)
		next({ name: 'login', params: { lastPage: from } })
		return
	}
	// if (store.state.isLoggedIn) {
	// 	var url
	// 	if (store.state.userRole == 'official')
	// 		url = '/authenticate/official'
	// 	else
	// 		if (store.state.userRole == 'admin')
	// 			url = '/authenticate/admin'
	// 	axios({
	// 		method: 'POST',
	// 		url: url,
	// 		headers: {
	// 			'token': localStorage.getItem('token')
	// 		}
	// 	}).then(response => {
	// 		if (!response.data.status) {
	// 			store.commit("sessionOut", true)
	// 			return
	// 		}
	// 		// else {
	// 			// alert(response.data.msg)
	// 		// }
	// 	})
	// 		.catch(err => {
	// 			var msg = err;
	// 			console.log(msg)
	// 		});
	// }
	const isOfficialRole = (role) => role === 'official' || role === 'EmergencyUser' || role === 'RRT';
	const isMinisterLogin = store.state.loginType === 'MASTER' && (store.state.minister === 'yes' || localStorage.getItem('minister') === 'yes');
	const isAnalystLogin = store.state.mainRole === 'analyst' || store.state.userRole === 'analyst' || store.state.loginType === 'ANALYST' || localStorage.getItem('userRole') === 'analyst';

	if (to.matched.some(route => route.meta.requiresAuth) && isAnalystLogin && !to.path.startsWith('/analyst')) {
		next({ name: 'analystSnakeRescued' })
		return
	}

	if ((to.name == 'login' || to.path == '/') && (store.state.isLoggedIn == true && isAnalystLogin)) {
		next({ name: 'analystSnakeRescued' })
		return
	}

	if (to.matched.some(route => route.meta.requiresAuth) && isMinisterLogin && !to.path.startsWith('/minister')) {
		next({ name: 'ministerDashboard' })
		return
	}

	if ((to.name == 'login' || to.path == '/') && (store.state.isLoggedIn == true && isMinisterLogin)) {
		next({ name: 'ministerDashboard' })
		return
	}

	if ((to.name == 'login' || to.path == '/') && (store.state.isLoggedIn == true && store.state.mainRole == 'admin') && (store.state.activeSection == 'hwc')) {
		next({ name: 'adminDashboard' })
		return
	}
	else if ((to.name == 'login' || to.path == '/') && (store.state.isLoggedIn == true && store.state.mainRole == 'admin') && (store.state.activeSection == 'sarpa')) {
		next({ name: 'sarpadashboard' })
		return
	}
	else if ((to.name == 'login' || to.path == '/') && (store.state.isLoggedIn == true && isOfficialRole(store.state.mainRole)) && (store.state.activeSection == 'hwc')) {
		next({ name: 'dashboard' })
		return
	}
	else if ((to.name == 'login' || to.path == '/') && (store.state.isLoggedIn == true && isOfficialRole(store.state.mainRole)) && (store.state.activeSection == 'sarpa')) {
		next({ name: 'officersarpadashboard' })
		return
	}

	if (to.matched.some(route => route.meta.role)) {
		const requiredRole = to.meta.role; // Get role required by the route
		const userRole = store.state.mainRole; // Get user role from Vuex

		if (requiredRole === 'minister') {
			if (!isMinisterLogin) {
				next({ name: '404pagenotfound' });
				return;
			}
		} else if (requiredRole === 'analyst') {
			if (!isAnalystLogin) {
				next({ name: '404pagenotfound' });
				return;
			}
		} else if (requiredRole === 'official') {
			if (!isOfficialRole(userRole)) {
				next({ name: '404pagenotfound' });
				return;
			}
		} else if (requiredRole !== userRole) {
			next({ name: '404pagenotfound' }); // Redirect to a 404 page if roles don't match
			return;
		}
	}

	next()
})

export default router
